import { useEffect, useRef } from 'react';

export function useInfiniteScrollObserver(callback: () => void) {
  const sentinelRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) callback();
      },
      {
        root: null, // window scroll
        rootMargin: '0px',
        threshold: 1.0,
      },
    );

    if (sentinelRef.current) {
      observer.observe(sentinelRef.current);
    }

    return () => {
      if (sentinelRef.current) {
        observer.unobserve(sentinelRef.current);
      }
    };
  }, [callback]);

  return sentinelRef;
}
